import { FlexCol } from '@/components/ui/flex';

import {
  MessageClassification,
  type DtUIMessage,
  type MessageAttachment,
} from '@ditto/shared';
import { type FC } from 'react';
import { Chat } from '.';

interface MessageRendererProps {
  message: DtUIMessage;
  messageIndex: number;
  isLastMessage: boolean;
  onFeedback: (scoreValue: 'up' | 'down', comment?: string) => void;
}

export const Message: FC<MessageRendererProps> = ({
  message,
  messageIndex,
  isLastMessage,
  onFeedback,
}) => {
  if (message.role === 'user') {
    return (
      <div>
        {message.metadata?.messageAttachments &&
          message.metadata?.messageAttachments.length > 0 && (
            <FlexCol gap="2" className="mb-3 flex items-end">
              {message.metadata?.messageAttachments.map(
                (attachment: MessageAttachment) => (
                  <Chat.MessageAttachment
                    key={attachment.id}
                    attachment={attachment}
                  />
                )
              )}
            </FlexCol>
          )}
        <Chat.UserMessage scrollToMessage={isLastMessage}>
          {message.parts
            .map(part => (part.type === 'text' ? part.text : ''))
            .join('')}
        </Chat.UserMessage>
      </div>
    );
  }

  // Check if this is a classification block message (out of scope or system question)
  if (
    message.metadata?.classification === MessageClassification.OUT_OF_SCOPE ||
    message.metadata?.classification === MessageClassification.SYSTEM
  ) {
    return (
      <div>
        <Chat.ClassificationBlock type={message.metadata?.classification} />
      </div>
    );
  }

  const parts = message.parts.filter(
    part => part.type === 'text' || part.type.startsWith('tool-')
  );
  if (parts.length === 0) {
    return null;
  }
  return (
    <div>
      {parts.map(
        (part, partIdx) =>
          part.type === 'text' && (
            <Chat.AiTextMessage
              key={`${message.id}-text-${messageIndex}-${partIdx}`}
              onFeedback={onFeedback}
              messageId={message.id}
            >
              {part.text}
            </Chat.AiTextMessage>
          )
      )}
    </div>
  );
};
